import { lazy } from "react";
import Profile from "../views/Profile.js";
import IndividualSite from "../views/IndividualSite.js";
import IndividualItem from "../views/IndividualItem.js";
import { AuthenticationGuard } from "./AuthenticationGuard.js";
import { Callback } from "../views/CallBack.js";
import NotFoundPage from "../views/NotFoundPage.js";
import Home from "../views/Home.js";
import LandingPage from "../views/Landing.js";
import NotRegistered from "../views/NotRegistered.js";
import Verify from "../views/Verify.js";
import Training from "../views/Training.js";
import Help from "../views/Help.js";
import Configuration from "../views/Configuration.js";
import DesignerPage from "../views/DesignerPage.js";
import Admin from "../views/Admin.js";
import Permissions from "../views/Permissions.js";
import GridPageRefactor from "../views/datagrids/DataGridRefactor/GridPage.js";

/*****Routes******/

const ThemeRoutes = [
  {
    path: "/*",
    element: <AuthenticationGuard component={Home} page="home" dbName="*" />,
  },
  {
    path: "callback",
    element: <Callback />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
    handle: {
      crumb: () => "Not Found",
    },
  },
  {
    path: "verify",
    element: <Verify />,
    handle: {
      crumb: () => "Not verified",
    },
  },
  {
    path: "notRegistered",
    element: <NotRegistered />,
    handle: {
      crumb: () => "Not Found",
    },
  },
  {
    path: "home/*",
    element: <AuthenticationGuard component={Home} page="home" dbName="*" />,
    handle: {
      crumb: () => "Home",
    },
  },
  // {
  // 	path: "login",
  // 	element: <LogIn />,
  // 	handle: {
  // 		crumb: () => "Home",
  // 	},
  // },
  {
    path: "landing/*",
    element: <LandingPage />,
    handle: {
      crumb: () => "Home",
    },
  },
  {
    path: "majorcategories/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="majorcategories"
        dbName="majorgroup"
      />
    ),
    handle: {
      crumb: () => "Major Categories",
    },
  },
  {
    path: "training/*",
    element: <AuthenticationGuard component={Training} page="training" />,
    handle: {
      crumb: () => "Training",
    },
  },
  {
    path: "help/*",
    element: <AuthenticationGuard component={Help} page="help" />,
    handle: {
      crumb: () => "Help",
    },
  },
  {
    path: "categories/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="categories"
        dbName="salesgroup"
      />
    ),
    handle: {
      crumb: () => "Categories",
    },
  },
  {
    path: "printers/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="printers"
        dbName="printer"
      />
    ),
    handle: {
      crumb: () => "Printers",
    },
  },
  {
    path: "sites/*",
    handle: {
      crumb: () => "Sites",
    },
    // element: (
    // 	<AuthenticationGuard
    // 		component={GridPageRefactor}
    // 		page="sites"
    // 		dbName="site"
    // 	/>
    // ),
    children: [
      {
        index: true,
        path: "*",
        element: (
          <AuthenticationGuard
            component={GridPageRefactor}
            page="sites"
            dbName="site"
          />
        ),
        handle: {
          crumb: () => "Sites",
        },
      },
      {
        path: ":id/*",
        element: <AuthenticationGuard component={IndividualSite} />,
        handle: {
          crumb: () => ":id",
        },
      },
    ],
  },

  {
    path: "items/*",
    handle: {
      crumb: () => "Items",
    },
    children: [
      {
        index: true,
        path: "*",
        element: (
          <AuthenticationGuard
            component={GridPageRefactor}
            page="items"
            dbName="plu"
          />
        ),
        handle: {
          crumb: () => "Items",
        },
      },
      {
        path: ":id/*",
        element: <AuthenticationGuard component={IndividualItem} />,
        handle: {
          crumb: () => ":id",
        },
      },
    ],
  },
  // { path: "menus", element: <BasicTable table={"Menus"} /> },
  {
    path: "tags/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="tags"
        dbName="tag"
        friendlyName="tags"
      />
    ),
    handle: {
      crumb: () => "Tags",
    },
  },
  {
    path: "pricing/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="pricings"
        dbName="pricing"
        friendlyName="prices"
      />
    ),
    handle: {
      crumb: () => "Pricing",
    },
  },
  {
    path: "staff/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="staff"
        dbName="server"
        friendlyName="servers"
      />
    ),
  },
  {
    path: "screens/*",
    element: (
      <AuthenticationGuard
        component={GridPageRefactor}
        page="screens"
        dbName="list"
      />
    ),
    handle: {
      crumb: () => "screens",
    },
  },

  {
    path: "designer/*",
    element: (
      <AuthenticationGuard
        component={DesignerPage}
        page="designer"
        dbName="list"
        friendlyName="screens"
      />
    ),
    handle: {
      crumb: () => "Designer",
    },
  },
  {
    path: "profile/*",
    element: <AuthenticationGuard component={Profile} />,
    handle: {
      crumb: () => "Profile",
    },
  },
  {
    path: "configuration/*",
    // element: (
    // 	<AuthenticationGuard component={Configuration} page="configuration" strict={true}/>
    // ),
    handle: {
      crumb: () => "Configuration",
    },
    children: [
      {
        index: true,
        path: "*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            friendlyName="this page"
            page={[
              "macros",
              "paymentMethods",
              "modifiers",
              "analysisCategories",
              "pricebands",
            ]}
            strict={true}
          />
        ),
        handle: {
          crumb: () => "Configuration",
        },
      },
      {
        path: "macros/*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            page="macros"
            friendlyName="macros"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "macros",
        },
      },
      {
        path: "paymentMethods/*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            page="paymentMethods"
            friendlyName="payment methods"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "paymentMethods",
        },
      },
      {
        path: "modifiers/*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            page="modifiers"
            friendlyName="modifiers"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "modifiers",
        },
      },
      {
        path: "pricebands/*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            page="pricebands"
            friendlyName="pricebands"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "pricebands",
        },
      },
      {
        path: "analysisCategories/*",
        element: (
          <AuthenticationGuard
            component={Configuration}
            page="analysisCategories"
            friendlyName="analysis categories"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "analysis Categories",
        },
      },
    ],
  },
  {
    path: "permissions/*",
    // element: <AuthenticationGuard component={Permissions} page={["permissions",'userType', 'user', 'policy']} strict={true}   />,
    handle: {
      crumb: () => "Permissions",
    },
    children: [
      {
        index: true,
        path: "*",
        element: (
          <AuthenticationGuard
            component={Permissions}
            friendlyName="this page"
            page={["permissions", "userTypes", "users", "policies"]}
            strict={true}
          />
        ),
        handle: {
          crumb: () => "Items",
        },
      },
      {
        path: "users/*",
        element: (
          <AuthenticationGuard
            component={Permissions}
            page="users"
            friendlyName="users"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "users",
        },
      },
      {
        path: "policies/*",
        element: (
          <AuthenticationGuard
            component={Permissions}
            page="policies"
            friendlyName="policies"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "policies",
        },
      },
      {
        path: "userTypes/*",
        element: (
          <AuthenticationGuard
            component={Permissions}
            page="userTypes"
            friendlyName="user types"
            strict={true}
          />
        ),
        handle: {
          crumb: () => "userTypes",
        },
      },
    ],
  },
  {
    path: "admin/*",
    element: (
      <AuthenticationGuard
        component={Admin}
        strict={true}
        page="settings"
        friendlyName="settings"
      />
    ),
    handle: {
      crumb: () => "Admin",
    },
  },
  {
    path: "newDataGrid/*",
    element: <AuthenticationGuard component={GridPageRefactor} page="staff" />,
    handle: {
      crumb: () => "Admin",
    },
  },
];

// const ThemeRoutes = [
// 	{
// 		path: "/",
// 		element: <Home />,
// 	},
// 	{
// 		path: "callback",
// 		element: <Callback />,
// 	},
// 	{
// 		path: "*",
// 		element: <NotFoundPage />,
// 		handle: {
// 			crumb: () => "Not Found",
// 		},
// 	},
// 	{
// 		path: "majorgroups",
// 		element: <GridPage page="majorgroups" />,

// 		handle: {
// 			crumb: () => "Major Groups",
// 		},
// 	},
// 	{
// 		path: "salesgroups",
// 		element: <GridPage page="salesgroups" />,

// 		handle: {
// 			crumb: () => "Sales Groups",
// 		},
// 	},
// 	{
// 		path: "sites",
// 		handle: {
// 			crumb: () => "Sites",
// 		},
// 		children: [
// 			{
// 				index: true,
// 				element: <GridPage page="sites" />,

// 				handle: {
// 					crumb: () => "Sites",
// 				},
// 			},
// 			{
// 				path: "/sites/:id",
// 				element: <IndividualSite />,

// 				handle: {
// 					crumb: () => ":id",
// 				},
// 			},
// 		],
// 	},

// 	{
// 		path: "items",
// 		handle: {
// 			crumb: () => "Items",
// 		},
// 		children: [
// 			{
// 				index: true,
// 				element: <GridPage page="items" />,

// 				handle: {
// 					crumb: () => "Items",
// 				},
// 			},
// 			{
// 				path: "/items/:id",
// 				element: <IndividualItem />,

// 				handle: {
// 					crumb: () => ":id",
// 				},
// 			},
// 		],
// 	},
// 	{
// 		path: "tags",
// 		element: <GridPage page="tags" />,

// 		handle: {
// 			crumb: () => "Tags",
// 		},
// 	},
// 	{
// 		path: "pricing",
// 		element: <GridPage page="pricings" />,

// 		handle: {
// 			crumb: () => "Pricing",
// 		},
// 	},
// 	{
// 		path: "servers",
// 		element: <GridPage page="servers" />,
// 		handle: {
// 			crumb: () => "Servers",
// 		},
// 	},
// 	{
// 		path: "lists",
// 		element: <GridPage page="lists" />,

// 		handle: {
// 			crumb: () => "lists",
// 		},
// 	},

// 	{
// 		path: "designer",
// 		element: <ListDesigner />,
// 		handle: {
// 			crumb: () => "Designer",
// 		},
// 	},
// 	{
// 		path: "profile",
// 		element: <Profile />,
// 		handle: {
// 			crumb: () => "Profile",
// 		},
// 	},

// ];

export default ThemeRoutes;
